export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const NOTIFICATIONS_LOADING = 'NOTIFICATIONS_LOADING';
export const NOTIFICATIONS_ERROR = 'NOTIFICATIONS_ERROR';
